/*
export const mediaQuery = `
  query getMediaQuery(
    $id_not_in: [Int]
    $popularity_greater: Int
    $page: Int
    $perPage: Int
  ) {
    Page(page: $page, perPage: $perPage) {
      pageInfo {
        hasNextPage
        lastPage
      }
      media(id_not_in: $id_not_in, popularity_greater: $popularity_greater) {
        id
        title {
          english
          romaji
          native
        }
        popularity
        coverImage {
          extraLarge
          color
        }
        
      }
    }
  }
`;
*/
export const charactersQuery = `
  query getCharactersQuery(
    $page: Int
    $perPage: Int
  ) { 
    Page(page: $page, perPage: $perPage) {
      pageInfo {
        hasNextPage
        lastPage
      }
      characters(sort: FAVOURITES_DESC) {
        id
        name {
          full
        }
        favourites
        image {
          large
        }
      }
    }
  }

`;

export const mediaQuery = `
  query getMediaQuery(
    $page: Int
    $perPage: Int
  ) {
    Page(page: $page, perPage: $perPage) {
      pageInfo {
        hasNextPage
        lastPage
      }
      media(sort: POPULARITY_DESC) {
        type
        id
        title {
          english
          romaji
          native
        }
        popularity
        coverImage {
          extraLarge
          color
        }
      }
    }
  }
`;

export const animeQuery = `
  query getAnimeQuery(
    $page: Int
    $perPage: Int
  ) {
    Page(page: $page, perPage: $perPage) {
      pageInfo {
        hasNextPage
        lastPage
      }
      media(sort: POPULARITY_DESC, type: ANIME) {
        type
        id
        title {
          english
          romaji
          native
        }
        popularity
        coverImage {
          extraLarge
          color
        }
      }
    }
  }
`;

export const mangaQuery = `
  query getMangaQuery(
    $page: Int
    $perPage: Int
  ) {
    Page(page: $page, perPage: $perPage) {
      pageInfo {
        hasNextPage
        lastPage
      }
      media(sort: POPULARITY_DESC, type: MANGA) {
        type
        id
        title {
          english
          romaji
          native
        }
        popularity
        coverImage {
          extraLarge
          color
        }
      }
    }
  }
`;
